import { AppIconByName } from '@/components/icons/app-icon-registry';

export function CmsEditorialIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  return <AppIconByName aria-hidden="true" className={className} name={name} />;
}
